export default function formatDateToSimpleIsoString(date: Date) {
  const pad = (val: number) => String(val).padStart(2, '0')

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate(),
  )}`
}
